import request from "@/common/request"
import { CanaldeVendas, Page } from "@/models"

const BASE_URL = `/canal-de-vendas`

export const get = async (id: string): Promise<CanaldeVendas> =>
	request.get(`${BASE_URL}/${id}`)

export const find = async (params?: any): Promise<Page<CanaldeVendas>> =>
	request.get(BASE_URL, {
		params: {
			...params,
		},
	})

export const create = async (formData: FormData): Promise<CanaldeVendas> =>
	request.post(BASE_URL, formData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	})

export const update = async (id: string, formData: FormData): Promise<CanaldeVendas> =>
	request.put(BASE_URL+`/${id}`, formData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	})

export const findCanalDeVendaDaVitrineVirtual = async (): Promise<CanaldeVendas> =>
	request.get(`${BASE_URL}/vitrine-virtual`)